import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'

const HelpText = ({userData}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const imageUrl = `${URL_STATICS_IMAGES}pictograms/Lock.svg`

  return (
    <div className="mt-TransactionBuyerProfession-helpText">
      <img
        src={imageUrl}
        height={48}
        width={58}
        alt={htmlStringToReactElement(
          i18n.t('VEHICLE_TRANSACTION.BUYER_PROFESSION.HELP_TEXT', {
            highlightStart: '',
            highlightEnd: ''
          })
        )}
      />
      <div className="mt-TransactionBuyerProfession-helpTextInfo">
        {htmlStringToReactElement(
          i18n.t('VEHICLE_TRANSACTION.BUYER_PROFESSION.HELP_TEXT', {
            highlightStart: '<strong>',
            highlightEnd: '</strong>'
          })
        )}
      </div>
    </div>
  )
}

HelpText.displayName = 'HelpText'
HelpText.propTypes = {
  userData: PropTypes.object
}

export default HelpText
